var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 474.34 168.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed2124;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.11,168.82L0,161.31,47.54,43.86h-31.44L35.28,8.76c1.8-3.46,5.37-5.64,9.28-5.64h79.51l-14.81,32.34,82.86-1.75c4.11-.07,8-1.82,10.79-4.83l15.51-16.73h39.67c1.14,0,1.73,1.37.95,2.2l-45.04,64.33c-1.34,1.92-.92,4.55.94,5.96l108.61,81.86c.49.33.12,1.08-.44.9L105.75,92.04l10.46-9.88c1.59-1.5.68-4.17-1.49-4.39l-39.21-4.08-21.44,54.99,141.62,1.91,112.33,38.23c.36.12,0,0-8.91,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.34,168.87h-127.47l73.26-53.1-8.65-29.77h0l-61.54,39.85c-1.91,1.55-4.69,1.38-6.4-.38l-54.68-56.52,1.29,65.09-64.86-54.13L279.55,0l70.26,84.44L423.71,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmLogo);
export default __webpack_public_path__ + "static/media/RM-logo.565c06f28445c9ba9118cae49cbc2a8c.svg";
export { ForwardRef as ReactComponent };